import {Decoder, field, number, object, string} from 'json-bouncer'

export interface InquiryPositionAttachment {
    readonly id: number
    readonly inquiryPositionId: number
    readonly filename: string
}

export function decoder(): Decoder<InquiryPositionAttachment> {
    return object(
        {
            id: field('id', number()),
            inquiryPositionId: field('inquiryPositionId', number()),
            filename: field('filename', string()),
        }
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryPositionAttachment.ts